import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";
import { fmtDate, chipPastel } from "components/sacrificesConfig";

const defaultForm = { nom: "", email: "", mot_de_passe: "" };

function MesDelegues() {
  const [delegues, setDelegues] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchDelegues = async () => {
    try {
      const res = await api.get("/delegues");
      setDelegues(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => { fetchDelegues(); }, []);

  const handleOpen = () => {
    setForm(defaultForm);
    setError("");
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleSubmit = async () => {
    if (!form.nom || !form.email || !form.mot_de_passe) {
      setError("Tous les champs sont obligatoires");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/delegues", form);
      fetchDelegues();
      handleClose();
    } catch (err) {
      setError(err.response?.data?.message || "Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (d) => {
    if (!window.confirm(`Supprimer le délégué ${d.nom} ?\nIl ne pourra plus se connecter.`)) return;
    try {
      await api.delete("/delegues/" + d.id);
      fetchDelegues();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur serveur");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2} mt={-3} py={3} px={2}
                variant="gradient" bgColor="info"
                borderRadius="lg" coloredShadow="info"
                display="flex" justifyContent="space-between" alignItems="center"
              >
                <MDTypography variant="h6" color="white">Mes délégués sacrifices</MDTypography>
                <MDButton variant="outlined" color="white" size="small" onClick={handleOpen}>
                  <Icon>person_add</Icon>&nbsp;Ajouter un délégué
                </MDButton>
              </MDBox>
              <MDBox pt={3} px={3} pb={3}>
                <MDTypography variant="caption" color="text" display="block" mb={2}>
                  Les délégués peuvent saisir et suivre les demandes de sacrifices de votre ville.
                </MDTypography>
                <Grid container spacing={3}>
                  {delegues.map((d) => (
                    <Grid item xs={12} md={6} lg={4} key={d.id}>
                      <Card sx={{ p: 2, border: "1px solid #eee" }}>
                        <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                          <MDTypography variant="h6">{d.nom}</MDTypography>
                          <Icon sx={{ cursor: "pointer", color: "error.main" }} onClick={() => handleDelete(d)}>
                            cancel
                          </Icon>
                        </MDBox>
                        <Chip label="Délégué sacrifices" size="small" sx={{ ...chipPastel("#7b1fa2"), mb: 1 }} />
                        <MDTypography variant="caption" color="text" display="block">
                          Email : {d.email}
                        </MDTypography>
                        {d.ville && (
                          <MDTypography variant="caption" color="text" display="block">
                            Ville : {d.ville}
                          </MDTypography>
                        )}
                        <MDTypography variant="caption" color="text" display="block">
                          Créé le : {fmtDate(d.created_at)}
                        </MDTypography>
                      </Card>
                    </Grid>
                  ))}
                  {delegues.length === 0 && (
                    <Grid item xs={12}>
                      <MDTypography variant="body2" color="text" textAlign="center">
                        Aucun délégué. Cliquez sur "Ajouter un délégué".
                      </MDTypography>
                    </Grid>
                  )}
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Ajouter un délégué</DialogTitle>
        <DialogContent>
          <MDBox display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="Nom complet" fullWidth
              value={form.nom}
              onChange={(e) => setForm({ ...form, nom: e.target.value })}
            />
            <TextField
              label="Email" type="email" fullWidth
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <TextField
              label="Mot de passe" type="password" fullWidth
              helperText="6 caractères minimum"
              value={form.mot_de_passe}
              onChange={(e) => setForm({ ...form, mot_de_passe: e.target.value })}
            />
            {error && (
              <MDTypography variant="caption" color="error">{error}</MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose} color="secondary">Annuler</MDButton>
          <MDButton onClick={handleSubmit} color="info" disabled={loading}>
            {loading ? "Enregistrement..." : "Ajouter"}
          </MDButton>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
}

export default MesDelegues;
